<div class="logout-container">
  <div id="splash">
    <mat-icon [svgIcon]="logo"></mat-icon>
  </div>
  <div class="signed-out-text">{{ 'logout.signedOut' | translate }}</div>
  <div class="sign-in-again-text">{{ 'logout.loginAgain' | translate }}</div>
  <button mat-raised-button color="primary" (click)="login()">{{ 'logout.button' | translate }}</button>
</div>
